import { useEffect } from "react";
import useApp from "../../hooks/useApp";
import {
  AUTH_FLOW,
  BACK_TO_LOGIN_PATHS,
  ROUTES,
  SEARCH_PARAMS,
} from "../../constants";
import "./styles.scss";
import useNavigateWithQuery from "../../hooks/useNavigateWithQuery";

const LoginScreen = () => {
  const navigate = useNavigateWithQuery();
  const {
    loginUrl,
    selectedLanguage,
    channel,
    tenant,
    flow,
    product,
    customPath,
    nafathService,
  } = useApp();

  useEffect(() => {
    const state = encodeURIComponent(
      `${SEARCH_PARAMS.TENANT}=${tenant}&${SEARCH_PARAMS.PRODUCT}=${product}&${SEARCH_PARAMS.CUSTOME_PATH}=${customPath}&${SEARCH_PARAMS.CHANNEL_ID}=${channel}&ui_locales=${selectedLanguage?.value}&${SEARCH_PARAMS.FLOW}=${flow}&${SEARCH_PARAMS.NAFATH_SERVICE}=${nafathService}&${SEARCH_PARAMS.APP_URL}=${`${window.location.origin}/app/${customPath}/${BACK_TO_LOGIN_PATHS.BACK_PRE_LOGIN}`}`
    );
    const finalUrl = `${loginUrl}&ui_locales=${selectedLanguage?.value}&state=${state}`;
    if (flow === AUTH_FLOW.CUSTOM_JOURNEY)
      navigate(`/${ROUTES.COMPANY_DETAILS}`);
    else if (loginUrl) window.location.href = finalUrl; // Redirect to the URL
  }, [loginUrl]);

  return null;
};

export default LoginScreen;
